export const cashOperationScopeTypeValues = ['location', 'treasury'] as const;
export type CashOperationScopeType = (typeof cashOperationScopeTypeValues)[number];

/** Stable identity persisted with every accepted Cash mutation. */
export interface CashOperationIdentityDto {
  operationId: string;
  requestHash: string;
  companyId: string;
  scopeType: CashOperationScopeType;
  scopeId: string;
  actorUserId: string;
  occurredAt: string;
}

/** Client-supplied portion of mutation identity. The server owns requestHash. */
export interface CashOperationRequestIdentity {
  operationId: string;
  occurredAt?: string;
}
